import { Capacitor } from "@capacitor/core";

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
        dataLayer?: unknown[];
    }
}

let googleAdsInitialized = false;

export function initGoogleAdsTag() {
    if (typeof window === "undefined") return;
    if (Capacitor.isNativePlatform()) return;
    if (googleAdsInitialized) return;

    const googleAdsId = process.env.REACT_APP_GOOGLE_ADS_ID;
    if (!googleAdsId?.startsWith("AW-")) return;

    googleAdsInitialized = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        function gtagShim(...args: any[]) {
            window.dataLayer?.push(args);
        };

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(googleAdsId)}`;
    document.head.appendChild(script);

    window.gtag("js", new Date());
    window.gtag("config", googleAdsId);
}

export function trackAdsConversion(conversionLabel: string, value?: number, currency?: string) {
    if (typeof window === "undefined") return;
    if (Capacitor.isNativePlatform()) return;
    initGoogleAdsTag();
    const gtag = window.gtag;
    if (typeof gtag !== "function") return;

    const sendTo = `${process.env.REACT_APP_GOOGLE_ADS_ID ?? ""}/${conversionLabel}`;
    if (!sendTo.startsWith("AW-") || sendTo.endsWith("/")) return;

    const payload: Record<string, unknown> = { send_to: sendTo };
    if (typeof value === "number") payload.value = value;
    if (currency) payload.currency = currency;

    gtag("event", "conversion", payload);
}

